/*
  HALO Outro Produto: vídeo em loop da coluna da esquerda.

  - Sem controles e sem pausa para o cliente: roda continuamente enquanto está na tela.
  - Só baixa quando a seção se aproxima da tela; fora dela (ou com a aba escondida) pausa
    sozinho, para não gastar bateria nem dados, e volta quando reaparece.
  - Para quem pede menos movimento no aparelho, fica parado na imagem.
*/
(function () {
  'use strict';

  // Streaming adaptativo (HLS) quando o navegador toca nativamente (iPhone, Android, Safari).
  var playsHls = document.createElement('video').canPlayType('application/vnd.apple.mpegurl') !== '';


  if (!window.customElements || customElements.get('halo-outro-produto')) return;

  var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  class HaloOutroProduto extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.video = this.querySelector('video[data-src]');
      if (!this.video || reduceQuery.matches) return;
      this.started = true;

      var self = this;
      this.ac = new AbortController();
      this.inView = false;

      this.video.addEventListener('playing', function () {
        self.video.classList.add('is-ready');
      }, { signal: this.ac.signal });

      this.near = new IntersectionObserver(function (entries) {
        if (entries[entries.length - 1].isIntersecting && !self.video.getAttribute('src')) {
          self.video.setAttribute('src', (playsHls && self.video.dataset.srcHls) || self.video.dataset.src);
        }
      }, { rootMargin: '400px 0px' });
      this.near.observe(this);

      this.io = new IntersectionObserver(function (entries) {
        self.inView = entries[entries.length - 1].isIntersecting;
        self.sync();
      }, { threshold: 0.1 });
      this.io.observe(this);

      document.addEventListener('visibilitychange', this.sync.bind(this), { signal: this.ac.signal });
    }

    disconnectedCallback() {
      if (!this.started) return;
      this.started = false;
      this.ac.abort();
      this.near.disconnect();
      this.io.disconnect();
      this.video.pause();
    }

    sync() {
      if (this.inView && !document.hidden) {
        if (!this.video.getAttribute('src')) this.video.setAttribute('src', (playsHls && this.video.dataset.srcHls) || this.video.dataset.src);
        this.video.muted = true;
        var played = this.video.play();
        if (played && played.catch) played.catch(function () {});
      } else if (!this.video.paused) {
        this.video.pause();
      }
    }
  }

  customElements.define('halo-outro-produto', HaloOutroProduto);
})();
